import React, { useEffect } from 'react'
import './PatientList.scss'
import '../../../../Dashboard/Dashboard.scss'
import SearchBoxPractice from '../../../../../../components/common/SearchBoxPractice/SearchBoxPractice'
import { useState } from 'react'
import PatientCards from './Components/PatientCards/PatientCards'
import PropTypes from 'prop-types'
import moment from 'moment/moment'
import { CFormSelect } from '@coreui/react-pro'
import { STATUS_GROUPS } from '../../../../../../utils/statusConstants'
import { getInitialprocedures } from '../../../../../../helper/backendHelper'

const patientStatus = [
  // { id: '0', name: 'Assigned to me', selected: false, count: 0 },
  { id: '1', name: 'Admits', selected: false, count: 0 },
  { id: '2', name: 'Discharges', selected: false, count: 0 },
  // { id: '3', name: 'New', selected: false, count: 0 },
]

const PatientList = ({ patients, selectedFacility, activeDate, dischargeCodes }) => {
  const [searchText, setSearchText] = useState('')
  const [initialProcedureCodes, setInitialProcedureCodes] = useState([])

  const [inPatients, setInPatients] = useState([])
  const [selectedFilter, setSelectedFilter] = useState('All')

  useEffect(() => {
    getInitialprocedures().then((resInitialProcedure) => {
      if (resInitialProcedure?.status === 'success') {
        setInitialProcedureCodes(
          resInitialProcedure.results.map((x) => {
            return x.code
          }),
        )
      }
    })
  }, [])

  const onFilter = (type) => {
    let searchResult = patients
      .filter((item) => item.facility_id === selectedFacility?._id)
      .filter(
        (pateintdataitem) =>
          pateintdataitem?.patient_firstname?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          pateintdataitem?.patient_lastname?.toLowerCase()?.includes(searchText.toLowerCase()) ||
          pateintdataitem?.patient_name?.toLowerCase()?.includes(searchText.toLowerCase()),
      )

    switch (type) {
      case '1':
        searchResult = searchResult.filter(
          (item) =>
            moment(item.admission_date, 'YYYY-MM-DD').isSame(
              moment(activeDate).format('YYYY-MM-DD'),
            ) || initialProcedureCodes.includes(item?.procedure_code_primary?.code),
        )
        break

      case '2':
        searchResult = searchResult.filter((item) => {
          let index = item?.statuses?.findIndex((res) => res.key === 'last_visit')
          if (index > -1) {
            return item?.statuses[index]?.value === true
          } else {
            return dischargeCodes.includes(item?.procedure_code_primary?.code)
          }
        })
        break

      case '3':
        searchResult = searchResult.filter((item) => item.stats_group === STATUS_GROUPS.available)
        break

      default:
        break
    }

    setInPatients(searchResult)
  }

  useEffect(() => {
    onFilter(selectedFilter)
  }, [selectedFilter, searchText, patients, selectedFacility])

  useEffect(() => {
    setSelectedFilter('All')
  }, [selectedFacility])

  return (
    <div className="patient-list">
      <div className="header-container">
        <span>
          <span className="header-component">Patient List</span>
          <span className="header-count ps-3">{inPatients?.length}</span>
        </span>
        <div>
          <CFormSelect
            className="dashboard-details-select"
            onChange={(e) => setSelectedFilter(e.target.value)}
            value={selectedFilter}
          >
            <option className="filter-text" value="All">
              All
            </option>
            {patientStatus.map((item) => (
              <option key={item.id} value={item.id} className="filter-text">
                {item?.name}
              </option>
            ))}
          </CFormSelect>
        </div>
      </div>
      <div className="margin-top mb-2">
        <SearchBoxPractice
          placeholder="Search patient"
          onChange={(value) => setSearchText(value)}
          value={searchText}
        />
      </div>

      {inPatients.length > 0 ? (
        <div className="patient-list-card-scroll">
          {inPatients?.map((item) => (
            <PatientCards key={item.id || item._id} patient={item} />
          ))}
        </div>
      ) : (
        <div className="noResults-list">
          <p>No results found</p>
        </div>
      )}
    </div>
  )
}

PatientList.propTypes = {
  patients: PropTypes.array,
  selectedFacility: PropTypes.object,
  activeDate: PropTypes.instanceOf(Date),
  dischargeCodes: PropTypes.array,
}

export default PatientList
